var _path, _circle, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 71,
    viewBox: "0 0 80 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 20C0 8.9543 8.9543 0 20 0H60C71.0457 0 80 8.95431 80 20V51C80 62.0457 71.0457 71 60 71H20C8.9543 71 0 62.0457 0 51V20Z",
    fill: "#14044D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 34,
    r: 20,
    fill: "#14044D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9012 35.546L40.0132 38.4676L32.125 35.546L40.0132 22L47.9012 35.546Z",
    fill: "#F4F4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5569 37.1738L40.0133 46.0004L32.4697 37.1738L40.0133 39.9677L47.5569 37.1738Z",
    fill: "#F4F4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0132 39.9677L47.5568 37.1738L40.0132 46.0004V39.9677Z",
    fill: "#F4F4F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9012 35.546L40.0132 38.4676V22L47.9012 35.546Z",
    fill: "#F4F4F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthw);
export default __webpack_public_path__ + "static/media/ethw.008217a0.svg";
export { ForwardRef as ReactComponent };